/* eslint-disable no-unused-expressions */
import TravelerInfoUIModel from './travelerInfo';
import CurrencyValueUIModel from './currency-value';
import EMDVoucherRs from './emd-voucher-rs';
import PricePerPassengerTypeMapUIModel from './price-per-passenger-type-map';

import passengerTypes from '../../scripts/constants/passenger-types-enum';
import CARD_TYPES from '../../scripts/constants/card-types-enum';

import UpsellOffersInfoUIModel from './upsellOffers';

class CartUIModel {
  constructor({
    corporateFrequentFlyerNumber = undefined,
    emdVoucherRs = undefined,
    fingerprintSessionId = undefined,
    travelerInfo = undefined,
    travelersCode = undefined,
    reservationStatus = undefined,
    pricePerPassengerTypeMap = undefined,
    upsellOffers = undefined,
    _meta = undefined,
  } = {}) {
    this.corporateFrequentFlyerNumber = corporateFrequentFlyerNumber;
    this.fingerprintSessionId = fingerprintSessionId;
    if (travelerInfo !== undefined) {
      this.travelerCollection = travelerInfo._collection.map(travelerData => {
        return new TravelerInfoUIModel(travelerData);
      });
    }
    this.travelersCode = travelersCode;
    this.reservationStatus = reservationStatus;
    if (_meta !== undefined) {
      this.cartExpirationTimeInSeconds = _meta.cartExpirationTimeInSeconds;
      this.cartId = _meta.cartId;
      this.paymentCPPoints = _meta.total.paymentCPPoints || false;
      const paymentCPPointsAux = this.paymentCPPoints;
      const reservationStatusAux = this.reservationStatus;
      this.total = _meta?.total?.currency ? new CurrencyValueUIModel({ ..._meta?.total?.currency, paymentCPPointsAux, reservationStatusAux }) : _meta?.total?.currency;
      this.points = _meta.total.points;
      this.amountTotal = _meta.total.currency ? this.total.getTotal() : 0.0;
      this.taxDetails = _meta.total.currency ? this.total.getTaxDetails() : {};
      this.totalTax = _meta.total.currency ? this.total.getTotalTax() : 0.0;
      this.bookingFee = _meta.total.currency ? _meta.total.currency.bookingFee : 0;
      this.fees = _meta?.total?.currency?.fees || {};
      this.totalWithoutBase = _meta?.total?.currency?.totalWithoutBase || 0;
      this.totalCPPoints = _meta?.total?.currency?.totalCPPoints || 0;
      this.baseOnlyFlight = _meta?.total?.currency?.baseOnlyFlight || 0;
      this.detailPaymentCPPoints = _meta?.total?.detailPaymentCPPoints || {};
    }
    this.emdVoucherRs = emdVoucherRs ? new EMDVoucherRs(emdVoucherRs) : null;
    this.pricePerPassengerTypeMap = pricePerPassengerTypeMap ? new PricePerPassengerTypeMapUIModel(pricePerPassengerTypeMap) : null;
    if (upsellOffers !== undefined) {
      this.upsellOffers = upsellOffers && upsellOffers._collection.map(upsellOffersData => {
        return new UpsellOffersInfoUIModel(upsellOffersData);
      });
    } else {
      this.upsellOffersCollection = upsellOffers;
    }
  }

  setCart(newTotal) {
    const paymentCPPointsAux = this.paymentCPPoints;
    const reservationStatusAux = this.reservationStatus;
    const bookingFee = this.bookingFee;
    const totalWithoutBase = this.totalWithoutBase;
    this.total = newTotal?._meta?.total?.currency ? new CurrencyValueUIModel({ ...newTotal?._meta?.total?.currency, paymentCPPointsAux, reservationStatusAux, bookingFee, totalWithoutBase }) : this.total;
    this.amountTotal = this.total.getTotal();
  }

  buildFullAncillariesList(ancillariesByTraveler) {
    const ancillaries = new Array();
    ancillariesByTraveler.forEach(traveler => {
      traveler.forEach(ancillary => {
        ancillaries.push(ancillary);
      });
    });
    return ancillaries;
  }

  getAllUnPaidAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getAllUnPaidAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getUnPaidAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getUnPaidAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getUnPaiFlyGreenAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getUnPaiFlyGreenAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getUnPaiPRIdAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getUnPaiPRIdAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getUnPaidAncillariesCP() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getUnPaidAncillariesCP();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getAllPaidAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getAllPaidAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getAllTicketedAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getTicketedAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getAllPassengers() {
    return this.travelerCollection;
  }

  /**
    * Devuelve el total a pagar del shopping cart
  */
  getAmountTotal() {
    return this.amountTotal;
  }

  getTotalPoints() {
    return this.total.getTotalPoints();
  }

  clearSessionCart() {
    this.travelerCollection.forEach(traveler => {
      traveler.clearSessionCart();
    });
    this.total.setTotalPoints(0);
  }

  getTotalExtras() {
    return this.getTotalForPaymentEMDVoucher() !== null ? (Math.trunc((this.getAmountTotal() * 100)) - Math.trunc(Math.round(this.getTotalForPaymentEMDVoucher() * 100))) / 100 : this.getAmountTotal();
  }

  getAmountForUnPaidExtras() {
    const unPaidAncillaries = this.getAllUnPaidAncillaries();
    let total = 0.0;

    unPaidAncillaries.forEach((item) => {
      if (item.ancillary && item.ancillary.ancillaryOffer && item.ancillary.ancillaryOffer.ancillary) {
        if (!item.isPaid) {
          total += item.ancillary.ancillaryOffer.ancillary.getTotal();
        }
      } else {
        if (!item.isPaid && !item.ancillaryOffer) {
          total += item.ancillary.getTotal();
        }
      }
    });

    const unPaidSeats = this.getAllUnPaidSegmentChoice();

    unPaidSeats.forEach((item) => {
      if (!item.isPaid) {
        total += item.seat.getTotal();
      }
    });

    return total;
  }

  /**
   * Return total from PNR
   */
  getCartTotal() {
    return this.total ? this.total.getTotal() : null;
  }

  getCurrencyCode() {
    return this.total.currencyCode;
  }

  getCostByLegForOnHold(numberOfLegs) {
    const totalToPay = this.getCartTotal();
    const totalOfUnPaidExtras = this.getAmountForUnPaidExtras();
    const totalTrunc = ( Math.trunc( ( totalToPay * 100 ) ) - Math.trunc( ( totalOfUnPaidExtras * 100 ) ) ) / 100;
    return numberOfLegs ? Math.trunc( ( totalTrunc * 100 ) / numberOfLegs ) / 100 : totalTrunc;
  }

  /**
    * Devuelve el total de impuestos
  */
  getTaxesTotal() {
    return this.total.getTotalTax();
  }

  /**
    * Lista de Impuestos
    * Devuelve pares de código y valor.
    * @return {[string, number][]} Devuelve una matriz de pares [taxCode, value], e.g. [["VAT", 10.99], ["OT", 1.50]]
  */
  getTaxDetailsAsList() {
    const taxDetailsList = [];
    const taxDetails = this.total.getTaxDetails();

    if (taxDetails) {
      for (const code in taxDetails) {
        if (!(this.reservationStatus === 'ON_HOLD' && this.paymentCPPoints && (code === 'MXA' || code === 'IVA'))) {
          taxDetailsList.push([code, taxDetails[code]]);
        }
      }
    }

    return taxDetailsList;
  }

  getAllUnPaidSegmentChoice(isOnHold = false) {
    const segmentChoices = new Array();
    this.travelerCollection.forEach(travelerInfo => {
      travelerInfo.getAllUnPaidSegmentChoice(isOnHold).forEach(segmentChoice => {
        segmentChoices.push(segmentChoice);
      });
    });
    return segmentChoices;
  }

  getAllPaidSegmentChoice(isOnHold = false) {
    const segmentChoices = new Array();
    this.travelerCollection.forEach(travelerInfo => {
      travelerInfo.getAllPaidSegmentChoice(isOnHold).forEach(segmentChoice => {
        segmentChoices.push(segmentChoice);
      });
    });
    return segmentChoices;
  }

  getUnPaidSegmentChoice(segments) {
    const segmentChoiceByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      segmentChoiceByTraveler[travelerInfo.id] = travelerInfo.getUnPaidSegmentChoice(segments);
    });
    return segmentChoiceByTraveler;
  }

  getBaggageUnPaidAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getBaggageUnPaidAncillaries();
    });
    return baggageByTraveler;
  }

  getCarryOnPaidAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getCarryOnPaidAncillaries();
    });

    return baggageByTraveler;
  }

  getBaggagePaidAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getBaggagePaidAncillaries();
    });

    return baggageByTraveler;
  }

  getExtraBaggagePaidAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getExtraBaggagePaidAncillaries();
    });

    return baggageByTraveler;
  }

  getBaggageUnPaidAncillariesPP() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getBaggageUnPaidAncillariesPP();
    });
    return baggageByTraveler;
  }

  getCarryOnUnPaidAncillaries() {
    const carryOnByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      carryOnByTraveler[travelerInfo.id] = travelerInfo.getCarryOnUnPaidAncillaries();
    });
    return carryOnByTraveler;
  }

  getCarryOnUnPaidAncillariesPP() {
    const carryOnByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      carryOnByTraveler[travelerInfo.id] = travelerInfo.getCarryOnUnPaidAncillariesPP();
    });
    return carryOnByTraveler;
  }

  getSpecialBaggageUnPaidAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getSpecialBaggageUnPaidAncillaries();
    });
    return baggageByTraveler;
  }

  getUnPaidSegmentChoiceLength() {
    return this.travelerCollection.length;
  }

  getCartCurrencyCode() {
    return this.total ? this.total.currencyCode : null;
  }

  getWeightBagByTravel(type, travelerIndex, legCode) {
    const traveler = this.travelerCollection[travelerIndex];
    return traveler.getWeightBagByTravel(type, legCode);
  }

  getWeightCarryOnByTravel(type, travelerIndex, legCode) {
    const traveler = this.travelerCollection[travelerIndex];
    return traveler.getWeightCarryOnByTravel(type, legCode);
  }

  setManageUserProfileAccount(userProfileAccount) {
    this.travelerCollection[0].setManageUserProfileAccount(userProfileAccount);
  }

  setUserIdCorporate(userId) {
    this.travelerCollection?.[0]?.setUserIdCorporate(userId);
  }

  setConcurFFNumber(ffNumber) {
    this.travelerCollection?.[0]?.setConcurFFNumber(ffNumber);
  }

  hasUnpaidAncillary() {
    if (!this.travelerCollection || !Array.isArray(this.travelerCollection)) {
      return false;
    }
    
    return this.travelerCollection.some(traveler => {
      return traveler && 
             typeof traveler.hasUnpaidAncillary === 'function' && 
             traveler.hasUnpaidAncillary();
    });
  }

  hasUnpaidAncillaryPP() {
    if (!this.travelerCollection || !Array.isArray(this.travelerCollection)) {
      return false;
    }
    
    return this.travelerCollection.some(traveler => {
      return traveler && 
             typeof traveler.hasUnpaidAncillaryPP === 'function' && 
             traveler.hasUnpaidAncillaryPP();
    });
  }

  hasUnpaidBaggagePP() {
    return !!this.travelerCollection.find(traveler => traveler.hasUnpaidBaggagePP());
  }

  hasUnpaidCarryOnPP() {
    return !!this.travelerCollection.find(traveler => traveler.hasUnpaidCarryOnPP());
  }

  hasUnpaidFlyGreen() {
    return this.travelerCollection.some(traveler => traveler.hasUnpaidFlyGreen());
  }

  hasUnpaidPriority() {
    return !!this.travelerCollection.find(traveler => traveler.hasUnpaidPriority());
  }

  hasUnpaidUpgrade() {
    return !!this.travelerCollection.find(traveler => traveler.hasUnpaidUpgrade());
  }

  hasUnpaidUpgradePP() {
    return !!this.travelerCollection.find(traveler => traveler.hasUnpaidUpgradePP());
  }

  hasUnpaidSeat() {
    let hasUnpaidSeat = false;
    hasUnpaidSeat = this.travelerCollection.find(traveler => {
      return traveler.hasUnpaidSeat() ? true : false;
    });
    return hasUnpaidSeat !== undefined ? true : false;
  }

  hasUnpaidSeatPP() {
    let hasUnpaidSeatPP = false;
    hasUnpaidSeatPP = this.travelerCollection.find(traveler => {
      return traveler.hasUnpaidSeatPP() ? true : false;
    });
    return hasUnpaidSeatPP !== undefined ? true : false;
  }

  getPaidCBX(legCodesAvailableMYB) {
    let getPaidCBX = 0;
    this.travelerCollection.forEach(traveler => {
      getPaidCBX += traveler.getPaidCBX(legCodesAvailableMYB) ? traveler.getPaidCBX(legCodesAvailableMYB).length : 0;
    });

    return getPaidCBX;
  }

  getQRCodeCBX(legCodesAvailableMYB) {
    let getQRCodeCBX = 0;
    this.travelerCollection.forEach(traveler => {
      getQRCodeCBX += traveler.getQRCodeCBX(legCodesAvailableMYB) ? traveler.getQRCodeCBX(legCodesAvailableMYB).length : 0;
    });

    return getQRCodeCBX;
  }

  updateTotalCart() {
    if (this.reservationStatus === 'ON_HOLD') {
      this.amountTotal = this.total.getTotal();
      this.taxDetails = this.total.getTaxDetails();
      this.totalTax = this.total.getTotalTax();
    } else {
      const ancillaries = this.getAllUnPaidAncillaries();
      const segmentChoices = this.getAllUnPaidSegmentChoice();
      let total = 0;
      let totalTax = 0;
      const taxDetails = {};
      ancillaries.forEach(ancillary => {
        total += ancillary.getGroupCode() === 'BG' ? ancillary.ancillary.getTotalPerLeg(ancillary.legCode) : ancillary.ancillary.getTotal();
        const ancillaryTaxDetails = ancillary.ancillary.getTaxDetails();
        Object.keys(ancillaryTaxDetails).forEach(codeTax => {
          const totTaxAnc = ancillaryTaxDetails[codeTax] || ancillary.ancillary.currency.totalTax;
          if (taxDetails.hasOwnProperty(codeTax)) {
            taxDetails[codeTax] += totTaxAnc;
          } else {
            taxDetails[codeTax] = totTaxAnc;
          }
          totalTax += totTaxAnc;
        });
      });
      segmentChoices.forEach(segmentChoice => {
        total += segmentChoice.getTotal();
        const ancillaryTaxDetails = segmentChoice.getTaxDetails();
        if ( ancillaryTaxDetails ) {
          Object.keys(ancillaryTaxDetails).forEach(codeTax => {
            if (taxDetails.hasOwnProperty(codeTax)) {
              taxDetails[codeTax] += ancillaryTaxDetails[codeTax];
            } else {
              taxDetails[codeTax] = ancillaryTaxDetails[codeTax];
            }
            totalTax += ancillaryTaxDetails[codeTax];
          });
        }
      });
      this.amountTotal = Math.trunc((total * 100)) / 100;
      this.taxDetails = taxDetails;
      this.totalTax = totalTax;
    }
  }

  setTravelerCollection(travelerCollection) {
    this.travelerCollection = travelerCollection._collection.map(travelerData => {
      return new TravelerInfoUIModel(travelerData);
    });
  }

  travelerInfoToApi() {
    return this.travelerCollection.map((travelerModel) => {
      return travelerModel.toApi();
    });
  }

  /**
   * Updates traveler model in travelerInfo
   *
   * @param {Object} travelerData
   * @param {String} travelerId - id of traveler to update
   * @param {String} [assignedTravelerId] - for infants, id of assigned traveler
   */
  updateTravelerInCart(travelerData, travelerId, assignedTravelerId) {
    let newTravelerModel = null;
    let travelerIndex = null;
    let updatedTravelerInfo = this.travelerInfo;

    if (assignedTravelerId) {
      // Updating infant in assigned traveler model
      travelerIndex = this.travelerInfo.findIndex(travelerModel => travelerModel.id === assignedTravelerId);
      newTravelerModel = this.travelerInfo.get(travelerIndex);
      newTravelerModel = newTravelerModel.updateTravelerWithInfant(travelerData);
    } else {
      // Updating non-infant traveler model
      travelerIndex = this.travelerInfo.findIndex(travelerModel => travelerModel.id === travelerId);
      newTravelerModel = this.travelerInfo.get(travelerIndex);
      newTravelerModel = newTravelerModel.updateTravelerModel(travelerData);

      // If primary traveler and multiple pax in booking, user is given the option
      // to use same emergency contact and/or destination address for all pax
      if (travelerIndex === 0 && this.travelerInfo.size > 1) {
        // If setting traveler info for all pax
        this.travelerInfo.forEach((travelerModel, i) => {
          if (i > 0 && travelerModel.paxType !== passengerTypes.INFANT) {
            // Update destination address/emergency contact for pax
            const updatedTraveler = travelerModel.updatePartialTravelerModel(travelerData);
            updatedTravelerInfo = updatedTravelerInfo.set(i, updatedTraveler);
          }
        });
      }
    }

    updatedTravelerInfo = updatedTravelerInfo.set(travelerIndex, newTravelerModel);
    return this.set('travelerInfo', updatedTravelerInfo);
  }

  getMealsAllowedSegments() {
    const travelersWithMealsSelectionAllowed = this.travelerCollection.filter( traveler => traveler.mealSelectionAllowed !== null );
    let mealsSegments = [];
    travelersWithMealsSelectionAllowed.forEach( traveler => {
      mealsSegments = mealsSegments.concat( traveler.mealSelectionAllowed );
    });
    return mealsSegments;
  }

  getNonInfantTravelers() {
    return this.travelerCollection.filter( traveler => traveler.paxType !== passengerTypes.INFANT );
  }

  isSelectedAncillary(typeAncillary) {
    const unPaidAncillaries = this.getUnPaidAncillaries().concat(this.getUnPaidAncillariesCP());
    const isInSelected = unPaidAncillaries.filter( ancillary => ancillary.getType() === typeAncillary );

    return isInSelected.length > 0;
  }

  isFullPaidAncillary(typeAncillary) {
    let isFullPaid = true;
    const newTravelerCollection = typeAncillary === 'SVI' ? this.travelerCollection.filter(traveler => traveler.isInsuranceAvailableForTraveler()) : this.travelerCollection;

    newTravelerCollection.forEach(traveler => {
      const isOptionKit = typeAncillary === 'AMS' || typeAncillary === 'AMK' || typeAncillary === 'DPM' || typeAncillary === 'SVI';
      let isInAncillaries = '';

      if (traveler && traveler.ancillaries && traveler.ancillaries.ancillaries) {
        isInAncillaries = traveler.ancillaries.ancillaries.find(ancillary => ancillary.type === typeAncillary || (isOptionKit && (ancillary.type === 'KEN' || ancillary.type === 'KEI')));
      }

      if (isInAncillaries === undefined || (!isInAncillaries.isPaid && !isInAncillaries.hasOwnProperty('emd'))) {
        isFullPaid = false;
      }
    });

    return isFullPaid;
  }

  isFullPaidFlyGreen(segments) {
    let isFullPaid = false;
    const numberOfSegments = segments?.length;
    const travelers = this.getNonInfantTravelers();
    const numberOfTravelers = travelers?.length;
    const totalPaidTravelers = numberOfSegments * numberOfTravelers;
    let isInAncillaries = 0;

    if (numberOfSegments > 0 && numberOfTravelers > 0) {
      segments.forEach(segment => {
        const segmentCode = segment?.segmentCode?.substr(0, 21);

        travelers.forEach(traveler => {
          const travelerAncillaries = traveler?.ancillaries?.ancillaries || [];

          if (travelerAncillaries) {
            travelerAncillaries.forEach(ancillary => {
              const segmentCodeAux = ancillary?.segmentCodeAux?.substr(0, 21);

              if (ancillary?.type === '09T' && ancillary?.isPaid && segmentCode === segmentCodeAux) {
                isInAncillaries ++;
              }
            });
          }

          if (totalPaidTravelers === isInAncillaries) {
            isFullPaid = true;
          }
        });
      });
    }

    return isFullPaid;
  }

  isFullPaidPriority(typeAncillary, segments) {
    let isFullPaid = false;
    const typePriority = typeAncillary === 'PRI';

    if (typePriority) {
      this.travelerCollection.forEach(traveler => {
        let isInAncillaries = 0;

        if (traveler?.ancillaries?.ancillaries) {
          traveler.ancillaries.ancillaries.forEach(ancillary => {
            if (ancillary && ancillary?.type === 'PRI' && ancillary?.isPaid === true) {
              isInAncillaries ++;
            }
          });
        }

        if (isInAncillaries === segments) {
          isFullPaid = true;
        }
      });
    }

    return isFullPaid;
  }

  isSomeSegmentsPaidPriority(typeAncillary, segments) {
    let isSomeSegmentPaid = false;
    const typePriority = typeAncillary === 'PRI';

    if (typePriority) {
      this.travelerCollection.forEach(traveler => {
        let isInAncillaries = 0;

        if (traveler && traveler.ancillaries && traveler.ancillaries.ancillaries) {
          traveler.ancillaries.ancillaries.forEach(ancillary => {
            if (ancillary && ancillary?.type === 'PRI' && ancillary?.isPaid === true) {
              isInAncillaries ++;
            }
          });
        }

        if (isInAncillaries > 0 && isInAncillaries !== segments) {
          isSomeSegmentPaid = true;
        }
      });
    }

    return isSomeSegmentPaid;
  }

  isPartiallyPaidAncillary(typeAncillary) {
    const payedAncillaries = this.getAllPaidAncillaries();
    const ticketedAncillaries = this.getAllTicketedAncillaries();

    const isInPayed = payedAncillaries.filter( ancillary => ancillary.getType() === typeAncillary );
    const isInTicketed = ticketedAncillaries.filter ( ancillary => ancillary.getType() === typeAncillary );

    return isInPayed.length > 0 || isInTicketed.length > 0;
  }

  addAncillaryToAllNoInfantTravelers(ancillary, legCodesArray = null) {
    // Agregar el ancillary a todos los pasajeros no infantes
    const noInfantTravelers = this.getNonInfantTravelers();
    noInfantTravelers.forEach( traveler => {
      traveler.addAncillary(ancillary, legCodesArray);
    });
  }

  quickAddAncillary(ancillary, legCodesArray = null) {
    this.addAncillaryToAllNoInfantTravelers(ancillary, legCodesArray);
  }

  hasEMDVoucher() {
    return this.emdVoucherRs !== null && this.emdVoucherRs !== undefined;
  }

  isValidEmdVoucher() {
    return this.emdVoucherRs.isValid();
  }

  getNumberVoucher() {
    return this.hasEMDVoucher() && this.isValidEmdVoucher() ? this.emdVoucherRs.getNumberVoucher() : null;
  }

  getErrorVoucher() {
    return this.hasEMDVoucher() ? this.emdVoucherRs.getErrorVoucher() : null;
  }

  getBalanceEMDVoucher() {
    const hasEMDVoucher = this.hasEMDVoucher();
    return hasEMDVoucher && this.isValidEmdVoucher() ? this.emdVoucherRs.getTotal() : 0;
  }

  getTotalForPaymentEMDVoucher() {
    return this.reservationStatus === 'ON_HOLD' && this.pricePerPassengerTypeMap.ADULT !== null ? this.pricePerPassengerTypeMap.ADULT.costUnit : null;
  }

  getTotalEMDVoucher() {
    const hasEMDVoucher = this.hasEMDVoucher();
    const totalOnlyFligth = this.getTotalForPaymentEMDVoucher();
    const totalEmdVoucher = this.getBalanceEMDVoucher();
    return hasEMDVoucher && this.isValidEmdVoucher() && totalOnlyFligth !== null ? totalEmdVoucher >= totalOnlyFligth ? totalOnlyFligth : totalEmdVoucher : 0.0;
  }

  getTotalForAncillaryPI() {
    const ancillaries = this.getAllUnPaidAncillaries();
    let total = 0;
    ancillaries.forEach(ancillary => {
      total += (ancillary?.ancillary?.type === 'AMS' || ancillary?.ancillary?.type === 'SEP' || ancillary?.ancillary?.type === 'SXP' || ancillary?.ancillary?.type === 'SXC' || ancillary?.ancillary?.type === 'SDE') ? ancillary.ancillary.getTotalPerLeg(ancillary.legCode) : 0;
    });
    return Math.trunc((total * 100)) / 100; 
  }

  getFormPaymentAvailable(formOfPayments) {
    if (this.reservationStatus === 'ON_HOLD' && this.paymentCPPoints) {
      const formPaymentsDefault = ['MYB_TITLE_CARDS_PP'];
      return formPaymentsDefault;
    }

    const totalOnlyFligth = this.getTotalForPaymentEMDVoucher();
    const numberPax = this.getAllPassengers().length;
    const hasEMDVoucher = this.hasEMDVoucher();
    const totalEmdVoucher = this.getBalanceEMDVoucher();
    const totalOfUnPaidExtras = this.getAmountForUnPaidExtras();
    const formPaymentsDefault = ['CREDIT', 'GIFT_CARD'];
    const hasEMDVoucherFormOfPayment = formOfPayments && formOfPayments.hasOwnProperty('hasEMDVoucherFormOfPayment') ? formOfPayments.hasEMDVoucherFormOfPayment : false;
    const formPaymentAvailable = this.reservationStatus === 'ON_HOLD' && hasEMDVoucherFormOfPayment ? // Es una reservacion on hold
      hasEMDVoucher && this.isValidEmdVoucher() ? // Tiene un EmdVoucher agregado en la reservación
        totalEmdVoucher >= totalOnlyFligth ? // El balance del voucher es mayor a el costo del vuelo
          totalOfUnPaidExtras > 0.0 || numberPax > 1 ? // Tiene ancillaries agregados la reservación o tiene más de un pasajero (sin contar infante)
            [CARD_TYPES.EMD_VOUCHER_TDD_TDC, CARD_TYPES.EMD_VOUCHER_UATP]
            : [CARD_TYPES.EMD_VOUCHER]
          : [CARD_TYPES.EMD_VOUCHER_TDD_TDC, CARD_TYPES.EMD_VOUCHER_UATP]
        : totalOfUnPaidExtras > 0.0 || numberPax > 1 ? // Tiene ancillaries agregados la reservación o tiene más de un pasajero (sin contar infante)
          [CARD_TYPES.EMD_VOUCHER_TDD_TDC, CARD_TYPES.EMD_VOUCHER_UATP]
          : [CARD_TYPES.EMD_VOUCHER]
      : [];
    return formPaymentAvailable.concat(formPaymentsDefault);
  }

  hasBenefitPreferedCP() {
    return this.travelerCollection.find(traveler => traveler.hasBenefitPreferedCP() === true) !== null;
  }

  hasBagCorporateRedeemed() {
    return this.travelerCollection && this.travelerCollection.some(traveler => traveler.hasBagCorporateRedeemed());
  }

  getLevelsTierBenefit() {
    const levels = this.travelerCollection
      .filter(traveler => traveler.getTypeBenefit() !== '')
      .map(traveler => `${traveler.getBenefitLevelSeat().charAt() + traveler.getBenefitLevelSeat().slice(1).toLowerCase().replace(' delta', '')}-${traveler.getTypeBenefit()}`);
    return levels.join('|');
  }

  getFFProgram() {
    const tierLevels = this.getLevelsTierBenefit();
    return tierLevels.includes('AM') ?
      tierLevels.includes('DL') ?
        'Aeroméxico Club Premier | Delta'
        : 'Aeroméxico Club Premier'
      : tierLevels.includes('DL') ?
        'Delta'
        : 'No FF';
  }

  setToken(token) {
    this.travelerCollection[0].setToken(token);
  }
}

export default CartUIModel;
